import React, { useState } from "react";
import { Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

import UserFavoritesRestaurant from "./InsidePageComponent/UserFavoritesRestaurant";
import UserFavoritesOffers from "./InsidePageComponent/UserFavoritesOffers";
import UserFavoritesEvents from "./InsidePageComponent/UserFavoritesEvents";

const SuperAdminMainUserFavorites = () => {
  const [selectedTab, setSelectedTab] = useState(1);

  const pageChangeButtonHandler = (value) => {
    setSelectedTab(value);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="left-side-panel">
          <LeftSideNavigation displayLink={1} />
        </div>
        <div className="super-admin-right-side-panel">
          <HomeReusableTopBarNavigation
            displayBack={true}
            backButtonLink="/superadmindashboard"
            displayText="Favorites"
          />
          <Col>
            <Col className="d-flex justify-content-between align-items-center pt-4 pb-3">
              <div className="f24_700_HelveticaNeue">Favourites Activity Report</div>
              {selectedTab === 1 ? (
                <NavLink
                  to="/superadminuserfavorite/group"
                  className="c_red font_24_m"
                >
                 Favourites Restaurant Summary Report
                </NavLink>
              ) : null || selectedTab === 2 ? (
                <NavLink
                  to="/superadminuserfavorite/group"
                  className="c_red font_24_m"
                >
                  Favourites Offers Summary Report
                  {/* Group By Offers */}
                </NavLink>
              ) : null || selectedTab === 3 ? (
                <NavLink
                  to="/superadminuserfavorite/group"
                  className="c_red font_24_m"
                >
                   Favourites Events Summary Report
                  {/* Group By Events */}
                </NavLink>
              ) : null}
            </Col>
          </Col>
          <div className="super-admin-inside-right-side-panel">
            {selectedTab === 1 ? (
              <UserFavoritesRestaurant
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
              />
            ) : null || selectedTab === 2 ? (
              <UserFavoritesOffers
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
              />
            ) : null || selectedTab === 3 ? (
              <UserFavoritesEvents
                pageChanger={pageChangeButtonHandler}
                selectedTab={selectedTab}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminMainUserFavorites;
